// @flow
import { useMemo, useState, useEffect } from 'react'
import styles from './index.module.scss'
import { useTranslation } from 'next-i18next'
import { Carousel } from 'antd'
import { handleToPortal } from '@/utils/sys'
import { useRouter } from 'next/router'
import mbanner1 from '@images/home/mbanner1.png'
import mbanner2 from '@images/home/mbanner2.png'
import mbanner3 from '@images/home/mbanner3.png'
// import mbanner4 from "@images/banner/bannner20230203.jpg";
import mbanner4 from '@images/banner/mbanner4.jpg'
import Image from 'next/image'
import TimeDown from '@/components/homeV3/pc/banner/Activity/TimeDown'
import buriedsdk from '@/utils/zz-buried/index'
import { useWidth } from '@/utils/resize'

type Props = {
  bannerList: Array<{
    type: string
    url: any
  }>
  info?: any
}
const Index = (props: Props) => {
  const { t, i18n } = useTranslation('home')
  const router = useRouter()
  const { width, display } = useWidth() //服务端
  const [timeDownVisible, setTimeDownVisible] = useState(true)

  useEffect(() => {
    setTimeDownVisible(true)
    // setTimeDownVisible(!!props.info.usable)
  }, [props.info.usable])

  const bannerData = useMemo(() => {
    const list = props.bannerList || []
    const defaultList = [
      { type: 'mbanner4', url: mbanner4 },
      { type: 'mbanner1', url: mbanner1 },
      { type: 'mbanner2', url: mbanner2 },
      { type: 'mbanner3', url: mbanner3 }
    ]
    return [...list, ...defaultList]
  }, [props.bannerList])

  const handleClaim = () => {
    const mobileUrl = process.env.mobileUrl
    const pcUrl = process.env.portalUrl
    const userInfo = sessionStorage.getItem('authorized-token')
    buriedsdk.buried({
      event: `按钮点击`,
      scene: `定价升级活动入口-操作台banner`,
      URL: process.env.publicApiDomain,
      json_str: JSON.stringify({
        marketing_id: props?.info?.marketingId,
        group_num: props?.info?.groupNum
      }),
      user_id: JSON.parse(userInfo || '{}')?.userId
    })
    setTimeout(() => {
      window.open(
        width > 1024 ? pcUrl + '/activity/list' : mobileUrl + '/newUserActivity',
        '_blank'
      )
    }, 500)
  }

  //倒计时结束
  const onTimeDownEnd = () => {
    setTimeDownVisible(false)
  }

  const clickBanner = (type) => {
    if (type === 'mActivity') {
      handleClaim()
      return
    }
    if (type === 'mbanner4') {
      window.location.href =
        'https://www.shoplus.net/tiktok-reports/tiktok-ecommerce-influencers-trend-report'
    }
  }

  return (
    <div className={`${styles.banner} `}>
      <Carousel dots={{ className: styles['custom-dot'] }}>
        {bannerData.map((item) => {
          return (
            <div
              className={`relative ${styles.container}`}
              onClick={() => clickBanner(item.type)}
              key={item.type}
            >
              {item.url ? <Image src={item.url} width={375} height={200} alt="banner" /> : null}
              {item.type === 'mActivity' ? (
                <div className={styles['mActivity-time']}>
                  {timeDownVisible ? (
                    <div className={`flex items-center ${styles['activity-expires']}`}>
                      <TimeDown
                        type="banner"
                        targetDate={props.info.usableEndTime}
                        onEnd={onTimeDownEnd}
                      />
                    </div>
                  ) : null}
                </div>
              ) : null}
            </div>
          )
        })}
      </Carousel>
      {/* <div className={`${styles.container} flex items-center justify-center`}>
        <div className={`${styles.left}`}>
          The best TikTok analytics platform
        </div>
        <div className={styles.pic}>
          <Image lazyBoundary="10px" src={image0} alt=""></Image>
        </div>
      </div> */}
    </div>
  )
}

export default Index
